var map = {
	"./arabic.json": 452,
	"./bulgarian.json": 453,
	"./czech.json": 454,
	"./denmark.json": 455,
	"./english.json": 456,
	"./finnish.json": 457,
	"./greek.json": 458,
	"./indonesian.json": 459,
	"./malay.json": 460,
	"./norwegian.json": 461,
	"./romanian.json": 462,
	"./slovakia.json": 463,
	"./swedish.json": 464
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2456;


//////////////////
// WEBPACK FOOTER
// ./src/locales/games4all [A-Za-z0-9-_,\s]+\.json$/
// module id = 2456
// module chunks = 0